var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as templateFactory from '../../../classes/definitions/template/template';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import templateSchema from '../../../schemas/templateSchema';
import TemplateService from '../../../services/template.service';
import Input from '../../UI/Input/Input';
var TemplateForm = /** @class */ (function (_super) {
    __extends(TemplateForm, _super);
    function TemplateForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.bottomMessages = null;
        _this.TemplateService = new TemplateService(_this.api);
        _this.imageChanged = false; // this will determine if the image has been changed
        _this.state = {
            formConfig: _.cloneDeep(templateSchema),
            formIsValid: false,
        };
        _this.getSearchTemplate = function (id) {
            _this.api
                .templateOneResult(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на търсенето';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var template = templateFactory.createTemplate(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _this.TemplateService.setDataToTemplateForm(updatedFormConfig, template);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            if (id === 'image' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.deleteHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = '';
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var image = _.get(formData, 'image.value', null);
            var submittedTemplate = new FormData();
            submittedTemplate.append('lead_banner[bg_name]', _.get(formData, 'name_bg.value', ''));
            submittedTemplate.append('lead_banner[en_name]', _.get(formData, 'name_en.value', ''));
            submittedTemplate.append('lead_banner[bg_button_name]', _.get(formData, 'button_value_bg.value', ''));
            submittedTemplate.append('lead_banner[en_button_name]', _.get(formData, 'button_value_en.value', ''));
            submittedTemplate.append('lead_banner[link]', _.get(formData, 'link_value.value', ''));
            submittedTemplate.append('lead_banner[template]', _.get(formData, 'template.value', ''));
            submittedTemplate.append('lead_banner[position]', _.get(formData, 'position.value', 50));
            if (_this.editId && _this.imageChanged && !image) {
                submittedTemplate.append('lead_banner[remove_image]', '1');
            }
            else if (_this.editId && _this.imageChanged && image) {
                submittedTemplate.append('lead_banner[image]', image);
            }
            else if (!_this.editId.length && _this.imageChanged && image) {
                // probably pointless, have to test
                submittedTemplate.append('lead_banner[image]', image);
            }
            var actionMethod = _this.editId === '-1' ? _this.api.createTemplate : _this.api.updateTemplate;
            actionMethod(submittedTemplate, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.bottomMessages.show({ severity: 'success', detail: 'Търсенето бе запазен успешно', life: 5000 });
                _this.toTemplatesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на търсене.';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toTemplatesPage = function () {
            _this.props.history.push(AppRoutes.templates.path);
        };
        return _this;
    }
    TemplateForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.id', '-1');
        if (this.editId !== '-1') {
            this.getSearchTemplate(this.editId);
        }
    };
    TemplateForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) {
                        return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                    }, blur: function (event) {
                        return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                    }, deleteButtonAction: function (event) {
                        return _this.deleteHandlers(event, formElement.id, 'onClick', formElement.config.elementType);
                    } })));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toTemplatesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            React.createElement(Messages, { ref: function (el) {
                    _this.bottomMessages = el;
                } }),
            actionBtns));
    };
    return TemplateForm;
}(React.Component));
// @ts-ignore
export default withRouter(TemplateForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Template/TemplateForm/TemplateForm.tsx
// module id = 487
// module chunks = 0